import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "Organisation",
    links: [
      { to: "/", label: "Home", id: "footer-home-link" },
      { to: "/about", label: "About NUC Service", id: "footer-about-link" },
      { to: "/services", label: "Services", id: "footer-services-link" },
      { to: "/notices", label: "Notices & News", id: "footer-notices-link" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/book", label: "Book a Service", id: "footer-book-link" },
      { to: "/contact", label: "Contact Us", id: "footer-contact-link" },
      { to: "/my-bookings", label: "My Bookings", id: "footer-my-bookings-link" },
      { to: "/login", label: "Login", id: "footer-login-link" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy", id: "footer-privacy-link" },
      { to: "/terms", label: "Terms & Conditions", id: "footer-terms-link" },
      { to: "/admin/login", label: "Admin Login", id: "footer-admin-link" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 md:grid-cols-12 lg:px-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span
              className="flex h-10 w-10 items-center justify-center rounded-md bg-blue-600 font-display text-base font-bold text-white"
              aria-hidden="true"
            >
              N
            </span>
            <span className="leading-tight">
              <span className="block font-display text-lg font-bold tracking-tight text-white">
                NUC Service
              </span>
              <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">
                National Union Corporation
              </span>
            </span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300">
            Supporting digital services, agriculture, rural development, employment, skills and
            community development — one booking, one camp, one family at a time.
          </p>
          <Link
            to="/book"
            data-testid="footer-book-button"
            className="mt-8 inline-block rounded-md bg-white px-6 py-3 text-sm font-semibold text-slate-900 transition-colors duration-200 hover:bg-blue-50"
          >
            Book a Service
          </Link>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
              {col.title}
            </p>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.id}>
                  <Link
                    to={l.to}
                    data-testid={l.id}
                    className="text-sm text-slate-300 transition-colors duration-200 hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-800">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
          <span>© 2026 NUC Service — National Union Corporation</span>
          <span>Serving communities with trust</span>
        </div>
      </div>
    </footer>
  );
}
